import React, { useState } from 'react';
import ProfileFormContainer from '../components/ProfileSteps/ProfileFormContainer';
import WelcomeScreen from '../components/ProfileSteps/WelcomeScreen';
import BasicInfo from '../components/ProfileSteps/BasicInfo';
import ContactInfo from '../components/ProfileSteps/ContactInfo';
import PrivacyOptions from '../components/ProfileSteps/PrivacyOptions';
import Documents from '../components/ProfileSteps/Documents';
import SearchGroup from '../components/ProfileSteps/SearchGroup';
import styles from './ProfileSetupPage.module.css';

const ProfileSetupPage = () => {
  const [currentStep, setCurrentStep] = useState(-1); 
  // start at -1, indicating the welcome screen
  
  const [userInfo, setUserInfo] = useState({
	  preferredFirstName: '',
	  legalFirstName: '',
	  legalLastName: '',
	  profileImage: null,
	});

  const formSteps = [
    { title: "Basic Information", component: <BasicInfo userInfo={userInfo} setUserInfo={setUserInfo} /> },
    { title: "Contact Information", component: <ContactInfo /> },
    { title: "Privacy Options", component: <PrivacyOptions /> },
    { title: "Documents", component: <Documents /> },
    { title: "Search Group", component: <SearchGroup /> },
  ];

  const handleStart = () => setCurrentStep(0);

  return (
    <div className={`${styles.container} ${currentStep === -1 ? styles.welcomeScreen : ''}`}>
      {currentStep === -1 ? (
        <WelcomeScreen onNext={handleStart} />
      ) : (
        <ProfileFormContainer
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
		  userInfo={userInfo}
          steps={formSteps.map(step => step.title)}
        >
          {formSteps[currentStep].component}
        </ProfileFormContainer>
      )}
    </div>
  );
};

export default ProfileSetupPage;
